export var CryptoTransactionStatus;
(function (CryptoTransactionStatus) {
    CryptoTransactionStatus["SUBMITTED"] = "SUBMITTED";
    CryptoTransactionStatus["COMPLETED"] = "COMPLETED";
    CryptoTransactionStatus["FAILED"] = "FAILED";
    CryptoTransactionStatus["REJECTED"] = "REJECTED";
})(CryptoTransactionStatus || (CryptoTransactionStatus = {}));
//# sourceMappingURL=cryptoTransaction.js.map